import { Row, Col } from 'src/componentes/grid';
import Input from 'src/componentes/input';
import { capitalizeFirstLetter } from 'src/utils/string';
import useAuth from 'src/hooks/useAuth';
import { useIntl } from 'react-intl';
import Checkbox from 'src/componentes/checkbox';
import PanelCollapse from 'src/componentes/panel-collapse';

import PeriodoData from 'src/paginas/data/periodo-data.jsx';
import ColaboradorEGrupoSimplificadoLookup from 'src/lookups/ColaboradorEGrupoSimplificadoLookup';
import ItemOrganizacaoLookup from 'src/lookups/item-organizacao';
import StatusAuditoriaRiscoLookup from 'src/lookups/status-auditoria-risco';
import AuditoriaRiscoLookup from 'src/lookups/auditoriaRisco';
import ModeloChecklistLookup from 'src/lookups/ModeloChecklistLookup';
import StatusAcaoLookup from 'src/lookups/status-acao';
import DesenharCampoCustomizado from 'src/paginas/item/campo-customizado/componentes/desenhar';

const AuditoriaRiscoSearch = ({ model, configuracao }) => {
  const { terms: resources } = useAuth();
  const intl = useIntl();

  const handleChangeFiltro = (field, value) => {
    model.getModel(field).requestChange(value);
  };

  return (
    <>
      <PanelCollapse
        header={intl.formatMessage({ id: 'label.informacoesBasicas' })}
        open={true}
        ehAccordionDrawer={true}
      >
        <Row>
          <Col md={12}>
            <Input model={model.getModel('nome')} />
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            <Input model={model.getModel('idIntegracao')} />
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            <Input model={model.getModel('descricao')} />
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            <ColaboradorEGrupoSimplificadoLookup
              abrirEmDrawer
              exibirGrupos={false}
              labelComoTitulo
              multi
              clearable
              model={{
                label: capitalizeFirstLetter(resources.responsaveis),
                value: model.getModel('responsaveisSimplificado').value,
                requestChange: model.getModel('responsaveisSimplificado')
                  .requestChange,
                errors: model.getModel('responsaveisSimplificado').errors,
              }}
            />
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            <ItemOrganizacaoLookup
              multi={true}
              model={{
                label: capitalizeFirstLetter(resources.areas),
                value: model.getModel('areas').value,
                requestChange: model.getModel('areas').requestChange,
              }}
              data={{ tiposIdSelecionaveis: [1, 2, 3] }}
            />
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            <Checkbox
              model={{
                label: intl.formatMessage(
                  { id: 'label.considerarAreasSubordinadas' },
                  { areas: resources.areas }
                ),
                value: model.getModel('areasSubordinadas').value,
                requestChange:
                  model.getModel('areasSubordinadas').requestChange,
              }}
              style={{ marginBottom: 16 }}
            />
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            <AuditoriaRiscoLookup
              multi={true}
              clearable
              model={{
                label: capitalizeFirstLetter(resources.auditorias),
                value: model.getModel('auditorias').value,
                requestChange: model.getModel('auditorias').requestChange,
              }}
            />
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            <Checkbox
              model={{
                label: intl.formatMessage(
                  { id: 'labelExibirApenasAuditoriasComPontosAuditoria' },
                  {
                    auditoria: resources.auditoria,
                    auditorias: resources.auditorias,
                  }
                ),
                value: model.getModel(
                  'exibirApenasAuditoriasComPontosAuditoria'
                ).value,
                requestChange: model.getModel(
                  'exibirApenasAuditoriasComPontosAuditoria'
                ).requestChange,
              }}
              style={{ marginBottom: 16 }}
            />
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            <ModeloChecklistLookup
              multi={true}
              clearable
              model={{
                label: intl.formatMessage({ id: 'labelChecklist' }),
                value: model.getModel('checklists').value,
                requestChange: model.getModel('checklists').requestChange,
              }}
            />
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            <StatusAuditoriaRiscoLookup
              multi={true}
              clearable
              model={{
                label: capitalizeFirstLetter(
                  intl.formatMessage({ id: 'status' })
                ),
                value: model.getModel('statusAuditoriaList').value,
                requestChange: model.getModel('statusAuditoriaList')
                  .requestChange,
              }}
            />
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            <PeriodoData
              model={{
                label: intl.formatMessage(
                  { id: 'tipoFiltroDataPeriodoAuditoriaRisco' },
                  { auditoria: resources.auditoria }
                ),
              }}
              clearable
              isDrawerFilter={true}
              data={{ idsIgnorados: [7, 8, 9, 10] }}
              tipoFiltroData={
                model.getModel('tipoFiltroDataPeriodoAuditoriaRisco').value
              }
              dataInicio={model.getModel('deDataInicial').value}
              dataTermino={model.getModel('ateDataFinal').value}
              tipoFiltroDataField={'tipoFiltroDataPeriodoAuditoriaRisco'}
              dataInicioField={'deDataInicial'}
              dataTerminoField={'ateDataFinal'}
              onChange={handleChangeFiltro}
              customLabelTipoPeriodo={capitalizeFirstLetter(
                intl.formatMessage(
                  { id: 'tipoFiltroDataPeriodoAuditoriaRisco' },
                  { auditoria: resources.auditoria }
                )
              )}
              customLabelDataInicio={capitalizeFirstLetter(
                intl.formatMessage({ id: 'deDataInicial' })
              )}
              customLabelDataTermino={capitalizeFirstLetter(
                intl.formatMessage({ id: 'ateDataFinal' })
              )}
            />
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            <StatusAcaoLookup
              multi={true}
              clearable
              model={{
                label: intl.formatMessage(
                  { id: 'statusAcao' },
                  { acao: resources.acao }
                ),
                value: model.getModel('statusAcaoList').value,
                requestChange: model.getModel('statusAcaoList').requestChange,
              }}
            />
          </Col>
        </Row>
      </PanelCollapse>
      {configuracao?.utilizarPontosAuditoria && (
        <PanelCollapse
          header={intl.formatMessage({ id: 'labelPontosAuditoria' })}
          open={false}
          ehAccordionDrawer={true}
        >
          <Row>
            <Col md={12}>
              <Input model={model.getModel('descricaoPontoAuditoria')} />
            </Col>
          </Row>
          {configuracao?.pontosAuditoriaCampoAnaliseAuditor?.id == 1 && (
            <Row>
              <Col md={12}>
                <Input model={model.getModel('analiseAuditor')} />
              </Col>
            </Row>
          )}
          {configuracao?.pontosAuditoriaCampoCausaRaiz?.id == 1 && (
            <Row>
              <Col md={12}>
                <Input model={model.getModel('causaRaiz')} />
              </Col>
            </Row>
          )}
          {configuracao?.pontosAuditoriaCampoRecomendacao?.id == 1 && (
            <Row>
              <Col md={12}>
                <Input model={model.getModel('recomendacao')} />
              </Col>
            </Row>
          )}
          {model.getModel('camposCustomizadosPontoAuditoria')?.value?.length >
            0 && (
            <Row>
              <Col md={12}>
                <DesenharCampoCustomizado
                  model={model.getModel('camposCustomizadosPontoAuditoria')}
                  mdFields={12}
                />
              </Col>
            </Row>
          )}
        </PanelCollapse>
      )}
      {model.getModel('camposCustomizados')?.value &&
        model.getModel('camposCustomizados').value.length > 0 && (
          <PanelCollapse
            header={intl.formatMessage({ id: 'informacoesComplementares' })}
            open={false}
            ehAccordionDrawer={true}
          >
            <Row>
              <Col md={12}>
                <DesenharCampoCustomizado
                  model={model.getModel('camposCustomizados')}
                  mdFields={12}
                />
              </Col>
            </Row>
          </PanelCollapse>
        )}
    </>
  );
};

export default AuditoriaRiscoSearch;
